(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const initLuxHeader = (root) => {

      if (!root || root.dataset.luxInitialized === 'true') return;

      root.dataset.luxInitialized = 'true';

      const header = root.querySelector('[data-lux-header]');

      const panels = Array.from(root.querySelectorAll('[data-lux-panel]'));

      let lastY = window.scrollY;

      let activeTrigger = null;

      const closePanels = () => {

        panels.forEach((panel) => {

          panel.classList.remove('is-open');

          panel.setAttribute('aria-hidden', 'true');

          panel.setAttribute('inert', '');

        });

        root.querySelectorAll('[data-lux-open]').forEach((button) => {

          button.setAttribute('aria-expanded', 'false');

        });

        document.body.classList.remove('lux-panel-open');

        if (activeTrigger) {

          activeTrigger.focus({ preventScroll: true });

        }

        activeTrigger = null;

      };

      const openPanel = (id, trigger) => {

        const panel = root.querySelector('#' + CSS.escape(id));

        if (!panel) return;

        closePanels();

        activeTrigger = trigger;

        panel.classList.add('is-open');

        panel.removeAttribute('inert');

        panel.setAttribute('aria-hidden', 'false');

        trigger.setAttribute('aria-expanded', 'true');

        document.body.classList.add('lux-panel-open');

        const input = panel.querySelector('[data-lux-search-input]');

        if (input) {

          window.setTimeout(() => input.focus(), 80);

        }

        const closeButton = panel.querySelector(

          '[data-lux-close]:not(.lux-panel__backdrop)'

        );

        if (closeButton) {

          closeButton.focus({ preventScroll: true });

        }

      };

      root.querySelectorAll('[data-lux-open]').forEach((button) => {

        button.addEventListener('click', () => {

          openPanel(button.dataset.luxOpen, button);

        });

      });

      root.querySelectorAll('[data-lux-close]').forEach((button) => {

        button.addEventListener('click', closePanels);

      });

      document.addEventListener('keydown', (event) => {

        if (event.key === 'Escape') {

          closePanels();

          root.querySelectorAll('[data-lux-mega-item].is-open').forEach((item) => {

            item.classList.remove('is-open');

            const toggle = item.querySelector('[data-lux-mega-toggle]');

            if (toggle) {

              toggle.setAttribute('aria-expanded', 'false');

            }

          });

        }

      });

      const megaItems = Array.from(

        root.querySelectorAll('[data-lux-mega-item]')

      );

      megaItems.forEach((item) => {

        const toggle = item.querySelector('[data-lux-mega-toggle]');

        if (!toggle) return;

        toggle.addEventListener('click', () => {

          const wasOpen = item.classList.contains('is-open');

          megaItems.forEach((other) => {

            other.classList.remove('is-open');

            const otherToggle = other.querySelector('[data-lux-mega-toggle]');

            if (otherToggle) {

              otherToggle.setAttribute('aria-expanded', 'false');

            }

          });

          if (!wasOpen) {

            item.classList.add('is-open');

            toggle.setAttribute('aria-expanded', 'true');

          }

        });

        item.addEventListener('mouseenter', () => {

          if (window.matchMedia('(hover: hover) and (min-width: 901px)').matches) {

            megaItems.forEach((other) => other.classList.remove('is-open'));

            item.classList.add('is-open');

            toggle.setAttribute('aria-expanded', 'true');

          }

        });

        item.addEventListener('mouseleave', () => {

          if (window.matchMedia('(hover: hover) and (min-width: 901px)').matches) {

            item.classList.remove('is-open');

            toggle.setAttribute('aria-expanded', 'false');

          }

        });

      });

      document.addEventListener('click', (event) => {

        if (!root.contains(event.target)) return;

        if (!event.target.closest('[data-lux-mega-item]')) {

          megaItems.forEach((item) => {

            item.classList.remove('is-open');

            const toggle = item.querySelector('[data-lux-mega-toggle]');

            if (toggle) {

              toggle.setAttribute('aria-expanded', 'false');

            }

          });

        }

      });

      if (header && header.hasAttribute('data-hide-on-scroll')) {

        window.addEventListener('scroll', () => {

          const y = window.scrollY;

          header.classList.toggle(

            'is-hidden',

            y > lastY &&

            y > 180 &&

            !document.body.classList.contains('lux-panel-open')

          );

          header.classList.toggle('is-scrolled', y > 12);

          if (y < 20) {

            header.classList.remove('is-hidden');

          }

          lastY = y;

        }, { passive: true });

      } else if (header) {

        window.addEventListener('scroll', () => {

          header.classList.toggle('is-scrolled', window.scrollY > 12);

        }, { passive: true });

      }

    };

    const boot = () => {

      document.querySelectorAll('.lux-header-section').forEach(initLuxHeader);

    };

    if (document.readyState === 'loading') {

      document.addEventListener('DOMContentLoaded', boot);

    } else {

      boot();

    }

    document.addEventListener('shopify:section:load', (event) => {

      initLuxHeader(event.target);

    });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pookie-header"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const initLuxHeader = (root) => {

      if (!root || root.dataset.luxInitialized === 'true') return;

      root.dataset.luxInitialized = 'true';

      const header = root.querySelector('[data-lux-header]');

      const panels = Array.from(root.querySelectorAll('[data-lux-panel]'));

      let lastY = window.scrollY;

      let activeTrigger = null;

      const closePanels = () => {

        panels.forEach((panel) => {

          panel.classList.remove('is-open');

          panel.setAttribute('aria-hidden', 'true');

          panel.setAttribute('inert', '');

        });

        root.querySelectorAll('[data-lux-open]').forEach((button) => {

          button.setAttribute('aria-expanded', 'false');

        });

        document.body.classList.remove('lux-panel-open');

        if (activeTrigger) {

          activeTrigger.focus({ preventScroll: true });

        }

        activeTrigger = null;

      };

      const openPanel = (id, trigger) => {

        const panel = root.querySelector('#' + CSS.escape(id));

        if (!panel) return;

        closePanels();

        activeTrigger = trigger;

        panel.classList.add('is-open');

        panel.removeAttribute('inert');

        panel.setAttribute('aria-hidden', 'false');

        trigger.setAttribute('aria-expanded', 'true');

        document.body.classList.add('lux-panel-open');

        const input = panel.querySelector('[data-lux-search-input]');

        if (input) {

          window.setTimeout(() => input.focus(), 80);

        }

        const closeButton = panel.querySelector(

          '[data-lux-close]:not(.lux-panel__backdrop)'

        );

        if (closeButton) {

          closeButton.focus({ preventScroll: true });

        }

      };

      root.querySelectorAll('[data-lux-open]').forEach((button) => {

        button.addEventListener('click', () => {

          openPanel(button.dataset.luxOpen, button);

        });

      });

      root.querySelectorAll('[data-lux-close]').forEach((button) => {

        button.addEventListener('click', closePanels);

      });

      document.addEventListener('keydown', (event) => {

        if (event.key === 'Escape') {

          closePanels();

          root.querySelectorAll('[data-lux-mega-item].is-open').forEach((item) => {

            item.classList.remove('is-open');

            const toggle = item.querySelector('[data-lux-mega-toggle]');

            if (toggle) {

              toggle.setAttribute('aria-expanded', 'false');

            }

          });

        }

      });

      const megaItems = Array.from(

        root.querySelectorAll('[data-lux-mega-item]')

      );

      megaItems.forEach((item) => {

        const toggle = item.querySelector('[data-lux-mega-toggle]');

        if (!toggle) return;

        toggle.addEventListener('click', () => {

          const wasOpen = item.classList.contains('is-open');

          megaItems.forEach((other) => {

            other.classList.remove('is-open');

            const otherToggle = other.querySelector('[data-lux-mega-toggle]');

            if (otherToggle) {

              otherToggle.setAttribute('aria-expanded', 'false');

            }

          });

          if (!wasOpen) {

            item.classList.add('is-open');

            toggle.setAttribute('aria-expanded', 'true');

          }

        });

        item.addEventListener('mouseenter', () => {

          if (window.matchMedia('(hover: hover) and (min-width: 901px)').matches) {

            megaItems.forEach((other) => other.classList.remove('is-open'));

            item.classList.add('is-open');

            toggle.setAttribute('aria-expanded', 'true');

          }

        });

        item.addEventListener('mouseleave', () => {

          if (window.matchMedia('(hover: hover) and (min-width: 901px)').matches) {

            item.classList.remove('is-open');

            toggle.setAttribute('aria-expanded', 'false');

          }

        });

      });

      document.addEventListener('click', (event) => {

        if (!root.contains(event.target)) return;

        if (!event.target.closest('[data-lux-mega-item]')) {

          megaItems.forEach((item) => {

            item.classList.remove('is-open');

            const toggle = item.querySelector('[data-lux-mega-toggle]');

            if (toggle) {

              toggle.setAttribute('aria-expanded', 'false');

            }

          });

        }

      });

      if (header && header.hasAttribute('data-hide-on-scroll')) {

        window.addEventListener('scroll', () => {

          const y = window.scrollY;

          header.classList.toggle(

            'is-hidden',

            y > lastY &&

            y > 180 &&

            !document.body.classList.contains('lux-panel-open')

          );

          header.classList.toggle('is-scrolled', y > 12);

          if (y < 20) {

            header.classList.remove('is-hidden');

          }

          lastY = y;

        }, { passive: true });

      } else if (header) {

        window.addEventListener('scroll', () => {

          header.classList.toggle('is-scrolled', window.scrollY > 12);

        }, { passive: true });

      }

    };

    const boot = () => {

      document.querySelectorAll('.lux-header-section').forEach(initLuxHeader);

    };

    if (document.readyState === 'loading') {

      document.addEventListener('DOMContentLoaded', boot);

    } else {

      boot();

    }

    document.addEventListener('shopify:section:load', (event) => {

      initLuxHeader(event.target);

    });

  })();


  } catch(e) { console.error(e); }
})();
})();
